export const RECOVERY_OTP = 'RECOVERY_OTP'
export const TOTP = 'TOTP'
export const WEB_AUTH = 'WEB_AUTHN'
